import React, { useState } from "react";
import { vendor_page_labels } from "../../../Constants/Labels";
import ImagesPreview from "../../ImagesPreview/ImagesPreview";
import RichTextEditor from "../../Global/RichTextEditor/RichTextEditor";
import "./ImageAndTextBlock.css";

const ImageAndTextBlock = ({
  data,
  onUpdate,
  id,
  onRemove,
  imageAndTextBlock,
  imageAndTextBlockImage,
  onChangeImageAndTextBlockField,
  onChangeImageAndTextBlockDescription,
  onOpenImageAndTextBlockImageSelector,
  onRemoveImageAndTextBlockImage,
  config,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localDescription, setLocalDescription] = useState(imageAndTextBlock?.description || "");
  const [isUserEditing, setIsUserEditing] = useState(false);
  const handleDescriptionChange = (name, value) => {
    setIsUserEditing(true);
    if (value !== localDescription) {
      setLocalDescription(value);
      onChangeImageAndTextBlockDescription(value);
    }
  };

  console.log("imageAndTextBlock", imageAndTextBlock, localDescription);


  return (
    <div className="block-container">
      <div className="block-header">
        <h4 className="block-title">
          {vendor_page_labels?.image_and_text_block?.title}
        </h4>
        <div className="block-actions">
          <button className="block-action-btn remove" onClick={onRemove}>
            <span className="mdi mdi-delete"></span> Remove
          </button>
        </div>
      </div>
      <div className="block-content">
        <div className="">
          <div className="card-body">
            <div className="col-12 row">
              <div className="col-6">
                <h6 className="mb-3">
                  {
                    vendor_page_labels?.image_and_text_block?.left_image
                      ?.title
                  }
                </h6>
                <div className="col-12">
                  <ImagesPreview
                    acceptMultipleFiles={false}
                    featuredImage={true}
                    savedImages={imageAndTextBlockImage}
                    userProfile={false}
                    style={{ width: "90%" }}
                    onOpen={onOpenImageAndTextBlockImageSelector}
                    deleteDisable={true}
                    selectedImageInfo={imageAndTextBlockImage}
                    onRemoveImageIds={onRemoveImageAndTextBlockImage}
                  />
                </div>
              </div>
              <div className="col-6">
                <h6 className="mb-3">
                  {
                    vendor_page_labels?.image_and_text_block?.right_content
                      ?.title
                  }
                </h6>
                <div className="col-lg-12 ">
                  <div className="form-group">
                    <label className="form-label">
                      {
                        vendor_page_labels?.image_and_text_block?.right_content
                          ?.heading
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="heading"
                      value={imageAndTextBlock?.["heading"] || ""}
                      onChange={(e) => onChangeImageAndTextBlockField(e, 'right_content')}
                    />
                  </div>
                </div>
                <div className="col-lg-12 mb-4">
                  <div className="form-group ">
                    <label className="form-label">
                      {
                        vendor_page_labels?.image_and_text_block?.right_content
                          ?.description
                      }
                    </label>
                    <RichTextEditor
                      name="description"
                      onChange={handleDescriptionChange}
                      value={localDescription}
                    />
                  </div>
                </div>
                <div className="col-lg-12 row">
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      {
                        vendor_page_labels?.image_and_text_block?.right_content
                          ?.primary_button_label
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="primary_button_label"
                      value={imageAndTextBlock?.["primary_button_label"] || ""}
                      onChange={(e) => onChangeImageAndTextBlockField(e, 'right_content')}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      {
                        vendor_page_labels?.image_and_text_block?.right_content
                          ?.primary_button_url
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="primary_button_url"
                      value={imageAndTextBlock?.["primary_button_url"] || ""}
                      onChange={(e) => onChangeImageAndTextBlockField(e, 'right_content')}
                    />
                  </div>
                </div>
                <div className="col-lg-12 row">
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      {
                        vendor_page_labels?.image_and_text_block?.right_content
                          ?.secondary_button_label
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="secondary_button_label"
                      value={
                        imageAndTextBlock?.["secondary_button_label"] || ""
                      }
                      onChange={(e) => onChangeImageAndTextBlockField(e, 'right_content')}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      {
                        vendor_page_labels?.image_and_text_block?.right_content
                          ?.secondary_button_url
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="secondary_button_url"
                      value={imageAndTextBlock?.["secondary_button_url"] || ""}
                      onChange={(e) => onChangeImageAndTextBlockField(e, 'right_content')}
                    />
                  </div>
                </div>
                <div className="col-lg-12 mb-4 row">
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      Popup Button Label
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="popup_button_label"
                      value={imageAndTextBlock?.["popup_button_label"] || ""}
                      onChange={(e) => onChangeImageAndTextBlockField(e, 'right_content')}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      Popup Video URL
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="popup_video_url"
                      value={imageAndTextBlock?.["popup_video_url"] || ""}
                      onChange={(e) => onChangeImageAndTextBlockField(e, 'right_content')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageAndTextBlock;
